import { useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import enUS from 'date-fns/locale/en-US';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import startOfWeek from 'date-fns/startOfWeek';

const Kalender = ({acara}) => {

  const locales = {
    'en-US': enUS,
  };

  console.log(acara)
  
  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
  });

  return (
    <Calendar
      localizer={localizer}
      startAccessor="start"
      endAccessor="end"
      style={{ height: '100vh' }}
      events={acara}
    />
  );
};

export default Kalender;
